import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
// import cv from "../../assets/ruhul_amin_sujon.pdf";
// import cv from "../../assets/Ruhul_Amin_Sujon_MERN.pdf";
import cv from "../../assets/Ruhul_Amin_Sujon_Laravel_Developer.pdf";
// import profile from "../../assets/ruhul_amin_sujon.png";
import "./about.scss";

const About = () => {
  const [data, setData] = useState({});

  const fetchProjects = async (project_title) => {
    try {
      const response = await fetch(`/${project_title}.json`); // Assuming `html.json` is in the public folder
      const data = await response.json();
      setData(data);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects("about"); // Fetch default projects on initial render
  }, []);
  return (
    <>
      <section className="about py-5" id="about">
        <Container className="py-xl-5 py-lg-3">
          <h1 className="pb-md-5 pb-4  text-uppercase text-center fw-bold">
            About Me
          </h1>
          <Row className="">
            <Col lg={6} className="text-center">
              <Image
                src={data.img ? data.img : ""}
                className="img-fluid profile__img"
                alt="Sujon"
              />
            </Col>
            <Col className="pr-xl-5 mt-xl-4 mt-lg-0 mt-4 ">
              <h2 className="fw-bold">
                I'm <span className="title"> {data.name ? data.name : ""}</span>
              </h2>
              <h4 className="">{data.title ? data.title : ""}</h4>
              <p className="fw-lighter  py-4">{data.desc ? data.desc : ""}</p>
              <div className="pt-3">
                <Button
                  size="lg"
                  target="_blank"
                  className="download_btn mx-2"
                  href={data.cv ? data.cv : ""}
                >
                  Download Resume
                </Button>
                <Button
                  target="_blank"
                  rel="noreferrer"
                  size="lg"
                  className="github_btn mx-2"
                  href={data.github ? data.github : ""}
                >
                  Github
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default About;
